import toast from 'react-hot-toast'

export const setErrorToast = (text: string) => {
	toast.error(text, {
		duration: 2000,
		style: {
			border: '1px solid #f86d6d',
			padding: '16px',
			color: '#f86d6d',
		},
		iconTheme: {
			primary: '#f86d6d',
			secondary: '#FFFAEE',
		},
	})
}
